import { render, staticRenderFns } from "./Source.vue?vue&type=template&id=a50dff9c&scoped=true&"
import script from "./Source.vue?vue&type=script&lang=js&"
export * from "./Source.vue?vue&type=script&lang=js&"
import style0 from "./Source.vue?vue&type=style&index=0&id=a50dff9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50dff9c",
  null
  
)

export default component.exports